import Translator from '../../classes/Translator/Translator';

const TermsAndConditionsLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};

export default TermsAndConditionsLogic;
